import { render, staticRenderFns } from "./RedirectModal.vue?vue&type=template&id=2e5b5518&scoped=true"
import script from "./RedirectModal.vue?vue&type=script&lang=ts"
export * from "./RedirectModal.vue?vue&type=script&lang=ts"
import style0 from "./RedirectModal.vue?vue&type=style&index=0&id=2e5b5518&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e5b5518",
  null
  
)

export default component.exports